export const DOCUMENT_COMPLETED_STATUSES = new Set(['signed']);
export const DOCUMENT_ARCHIVED_STATUSES = new Set(['cancelled', 'expired']);

const normalizeDocumentStatus = (status) => String(status || '').trim().toLowerCase();

export const classifySigningRequests = (items = []) => {
  const list = Array.isArray(items) ? items : [];
  const activeItems = [];
  const completedItems = [];
  const archivedItems = [];

  list.forEach((item) => {
    const normalizedStatus = normalizeDocumentStatus(item?.status);
    if (DOCUMENT_COMPLETED_STATUSES.has(normalizedStatus)) {
      completedItems.push(item);
      return;
    }
    if (DOCUMENT_ARCHIVED_STATUSES.has(normalizedStatus)) {
      archivedItems.push(item);
      return;
    }
    activeItems.push(item);
  });

  return {
    totalCount: list.length,
    activeCount: activeItems.length,
    completedCount: completedItems.length,
    archivedCount: archivedItems.length,
    activeItems,
    completedItems,
    archivedItems,
  };
};

